import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import type { Id } from "@convex/_generated/dataModel";
import { useLeagueGame } from "@/features/leagues/games/hooks/useLeagueGame";
import { GameDetailHeader } from "@/features/leagues/games/components/GameDetailHeader";
import { GameStatLinesTable } from "@/features/leagues/games/components/GameStatLinesTable";
import { MyPlayersGameSummary } from "@/features/leagues/games/components/MyPlayersGameSummary";
import { PageContainer } from "@/shared/layout/PageContainer";
import { useT } from "@/shared/i18n/LocaleContext";
import { Skeleton } from "@/shared/ui/Skeleton";

export const Route = createFileRoute("/_authenticated/leagues/$leagueId/games/$gameId")({
  component: LeagueGameDetailPage,
});

function LeagueGameDetailPage() {
  const { leagueId, gameId } = Route.useParams();
  const t = useT();
  const data = useLeagueGame(leagueId as Id<"leagues">, gameId as Id<"games">);

  return (
    <PageContainer>
      <Link
        to="/leagues/$leagueId/games"
        params={{ leagueId }}
        className="inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-[0.18em] text-muted hover:text-ink transition-colors mb-4"
      >
        <ArrowLeft size={14} />
        {t("league.games.detail.backToList")}
      </Link>

      {data === undefined ? (
        <div className="flex flex-col gap-3">
          <Skeleton className="h-32 w-full" />
          <Skeleton className="h-24 w-full" />
          <Skeleton className="h-12 w-full" />
        </div>
      ) : (
        <>
          <GameDetailHeader
            game={data.game}
            homeTeam={data.homeTeam}
            awayTeam={data.awayTeam}
          />
          <MyPlayersGameSummary lines={data.lines} />
          <GameStatLinesTable lines={data.lines} />
        </>
      )}
    </PageContainer>
  );
}
